import { ref } from '@vue/composition-api'

export default function createBlobs() {
  const blobs = ref([])

  const isBinaryFile = file => file instanceof File

  const convertFilesToBlob = files => {
    blobs.value = []
    files.filter(file => file).forEach(file => {
      blobs.value.push(isBinaryFile(file.url) ? URL.createObjectURL(file.url) : file.url)
    })
  }

  const clearBlobs = () => {
    blobs.value.forEach(image => {
      URL.revokeObjectURL(image)
    })
    blobs.value = []
  }

  return { blobs, convertFilesToBlob, clearBlobs }
}
